import api from '../../plugins/api'

export default {
  namespaced: true,
  state: {items: []},
  actions: {
    async fetchItems({commit}, params = {}) {
      const items = await api.CvDeadline.fetch(params)
      commit('changeState', {items})
    },
    upgrade(_, params = {}) {
      return api.CvDeadline.upgrade(params)
    },
  },
  getters: {
    items: state => state.items,
  },
}
